<template>
  <header
    class="relative z-header w-full flex flex-shrink-0 items-center justify-between mb-4"
  >
    <div class="navigation container w-full flex items-center justify-between relative py-4 bg-white border-b border-au_gray-200">
      <div>
        <div class="logo" />
      </div>

      <div>
        <div
          v-on-clickaway="closeLanguageSwitcher"
          class="lang-switch relative"
          :class="{ open: showLanguageSwitcher }"
        >
          <div
            class="trigger cursor-pointer"
            @click="toggleLanguageSwitcher"
          >
            <div class="w-6 h-6 xl:w-7 xl:h-7">
              <svg fill="none" viewBox="0 0 35.465 35.465" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#000"><path d="M17.664 32.924c-7.91 0-14.345-6.795-14.345-15.148S9.754 2.63 17.664 2.63 32.01 9.43 32.01 17.776s-6.436 15.148-14.345 15.148zm0-29.556C10.14 3.368 4.02 9.83 4.02 17.776s6.121 14.41 13.645 14.41S31.31 25.72 31.31 17.775 25.187 3.368 17.664 3.368z"/><path d="M17.664 32.924c-1.479 0-2.857-1.608-3.879-4.527a33.376 33.376 0 01-1.543-10.62c-.062-3.601.46-7.187 1.543-10.62 1.022-2.92 2.4-4.528 3.88-4.528s2.856 1.608 3.878 4.527a33.375 33.375 0 011.543 10.62c.062 3.6-.459 7.187-1.543 10.62-1.022 2.92-2.4 4.528-3.879 4.528zm0-29.556c-1.284 0-2.505 1.466-3.437 4.13a32.329 32.329 0 00-1.485 10.278 32.33 32.33 0 001.487 10.28c.932 2.662 2.153 4.128 3.437 4.128s2.505-1.467 3.437-4.129a32.327 32.327 0 001.487-10.279 32.327 32.327 0 00-1.487-10.279c-.934-2.663-2.155-4.129-3.439-4.129z"/><path d="M17.664 32.924c-.137 0-.249-.165-.249-.369V2.998c0-.2.111-.369.25-.369s.248.165.248.37v29.555c.002.205-.112.37-.249.37z"/><path d="M31.658 18.028H3.67c-.193 0-.35-.11-.35-.249s.157-.249.35-.249h27.99c.192 0 .35.111.35.25s-.158.248-.35.248zM30.35 11.621H4.977c-.2 0-.365-.11-.365-.249s.163-.249.365-.249H30.35c.2 0 .365.111.365.25s-.164.248-.365.248zM30.35 25.03H4.977c-.2 0-.365-.11-.365-.249s.163-.249.365-.249H30.35c.2 0 .365.111.365.25s-.164.248-.365.248z"/><path d="M17.732 0a16.336 16.336 0 0111.924 5.2 18.441 18.441 0 011.218 23.65l-.273.35.2.4a6.8 6.8 0 002.822 3.2 1.265 1.265 0 01.654 1.32 1.205 1.205 0 01-1 1.06 8.085 8.085 0 01-1.32.105 9.983 9.983 0 01-5.689-1.824l-.325-.229-.346.191a16.2 16.2 0 01-7.864 2.042 16.335 16.335 0 01-11.924-5.2A18.068 18.068 0 01.88 17.732a18.094 18.094 0 014.94-12.546A16.34 16.34 0 0117.733 0h-.002zm0 1.2A15.25 15.25 0 006.62 6.04a16.883 16.883 0 00-4.6 11.692 16.888 16.888 0 004.6 11.692 15.247 15.247 0 0011.115 4.842 15.07 15.07 0 007.957-2.276.542.542 0 01.633.04 8.95 8.95 0 004.878 2.015l1.954.175-1.456-1.378a10.13 10.13 0 01-2.287-3.528.601.601 0 01.1-.63 17.18 17.18 0 00-.669-22.648A15.244 15.244 0 0017.735 1.2z"/></g></svg>
            </div>
          </div>
          <div
            class="dropdown hidden absolute right-0 top-0 w-48 mt-10 -mr-4 px-4 py-1 bg-white shadow-7 xl:-mr-5 xl:mt-12 xl:text-lg"
          >
            <ul>
              <li
                v-for="(locale, i) in availableLocales"
                :key="`Lang${i}`"
                class="leading-none cursor-pointer py-2"
                @click.prevent="changeLocale(locale)"
              >
                {{ $t(`locales.${locale}`) }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import Vue from 'vue'
import { mixin as clickaway } from 'vue-clickaway'

export default Vue.extend({
  mixins: [clickaway],

  data(): {
    showLanguageSwitcher: boolean;
  } {
    return {
      showLanguageSwitcher: false,
    }
  },
  computed: {
    availableLocales(): string[] {
      return this.$i18n.availableLocales.filter((locale) => locale !== this.currentLocale)
    },
    currentLocale(): string {
      return this.$i18n.locale
    },
  },

  /*
  mounted() {
    window.onbeforeunload = (event: Event) => {
      // TODO: every window.location or a href with outside link needs
      // to skip the code below in order to prevent the popup.
      // (since this is a wanted redirection compared to a page refresh or page close)
      // This can be done, so that for every link we dispatch an action,
      // that sets a state before actually doing the redirect.
      // Then in this function, if that variable is set to true
      // don't show a popup warning on leave.
      // event.preventDefault() // per the standard
      // event.returnValue = '' // required for Chrome
    }
  },
  */

  methods: {
    toggleLanguageSwitcher() {
      this.showLanguageSwitcher = !this.showLanguageSwitcher
    },
    closeLanguageSwitcher() {
      this.showLanguageSwitcher = false
    },
    changeLocale(locale: string) {
      this.$store.dispatch('locale/set', { locale })
    },
  },
})
</script>

<style lang="scss" scoped>
.navigation {
  height: 60px;
}

.logo {
  width: 183px;
  height: 25px;
  background: url('~images/psp/austrian/austrian-logo.svg') 0 0 / 183px 25px no-repeat;
}

.lang-switch {
  .dropdown {
    &::before {
      content: "";
      position: absolute;
      right: 24px;
      top: -5px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 6px 5px 6px;
      border-color: transparent transparent #FFFFFF transparent;

    }

    &::after {
      position: absolute;
      right: 24px;
      top: 0;
      width: 30px;
      height: 8px;
      content: '';
      background: white;
    }
  }

  &.open {
    .dropdown {
      @apply block;
    }
  }
}

@screen xl {
  .navigation {
    height: 90px;
  }

  .logo {
    width: 241px;
    height: 35px;
    background-size: 241px 35px;
  }

  .lang-switch {
    .dropdown {
      &::before {
        right: 32px;
      }

      &::after {
        right: 32px;
      }
    }
  }
}
</style>
